import{jsx as r}from"react/jsx-runtime";import{createSvgIcon as t}from"@mui/material/utils";var a=t(r("path",{d:"M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"}),"ArrowBackIos");export{a as default};
//# sourceMappingURL=ArrowBackIos.js.map
